<h1 mat-dialog-title>Solicitud de Pedido</h1>
<div mat-dialog-content>
    <mat-divider class="mat-divider-style"></mat-divider>
    <div *ngFor="let alarma of tanquesConAlarmasNivel">
        <div class="container">
            <div>
                <p class="gris">Detectado el: <span class="negro">{{ alarma.created_at }}</span></p>
                <p class="gris">Establecimiento: <span class="negro">{{ alarma.est_name }}</span></p>
                <p class="gris">Establecimiento ID: <span class="negro">{{ alarma.est_id }}</span></p>
                <!--<p class="negro">Ref. Dispositivo: <span class="gris">{{ alarma.dev_reference }}</span></p>
                <p class="negro">Nombre Dispositivo: <span class="gris">{{ alarma.dev_label }}</span></p>-->
                <p class="gris">Número de tanque: <span class="negro">{{ alarma.tankJson.custom_num }}</span></p>
                <!--<p class="negro">Cerveza: <span class="gris">{{ alarma.tank_beertype }}</span></p>-->
                <p class="gris">Cantidad solicitada: <span class="negro">{{ alarma.tankJson.capacity }} Litros</span></p>
                <p *ngIf="pro_id === 4" class="gris">Nivel actual del tanque: <span class="negro">{{ alarma.device_lastReader?.[alarma.fieldNivel] != null ? changeDotToComma(alarma.device_lastReader[alarma.fieldNivel]) : '--' }} Litros</span></p>
                <p *ngIf="pro_id != 4" class="gris">Nivel actual del tanque: <span class="negro">{{ alarma.device_lastReader?.[alarma.fieldNivel] != null ? (alarma.device_lastReader[alarma.fieldNivel] < 0 ? 0 : changeDotToComma(alarma.device_lastReader[alarma.fieldNivel])) : '--' }} Litros</span></p>
                <!--<p class="negro">Descripción de alarma: <span [ngStyle]="{'color': alarma.backgroundColor}" >{{ alarma.status }}</span></p>-->
                <!-- <p class="grisBold">Ritmo de consumo: <span class="naranjaBold">{{ alarma.tankJson?.consumption_rate != null ? changeDotToComma(alarma.tankJson.consumption_rate) : '0,00' }} litro/s por día</span></p> -->
                <p *ngIf="pro_id === 4" class="grisBold">Días Restantes: <span class="naranjaBold">{{ alarma.tankJson?.prediction_days != null ? changeDotToComma(alarma.tankJson.prediction_days) : '--' }} día/s</span></p>
                <p *ngIf="pro_id != 4" class="grisBold">Días Restantes: <span class="naranjaBold">{{ alarma.tankJson?.prediction_days != null ? (alarma.tankJson.prediction_days < 0 ? 0 : changeDotToComma(alarma.tankJson.prediction_days)) : '--' }} día/s</span></p>
            </div>
            <div class="boton-container">
                <button 
                    mat-stroked-button 
                    *ngIf="tanquesSeleccionados().length === 0"
                    class="boton-style"
                    (click)="recargarTanque(alarma.establishment_id, alarma.tankJson.id)"
                    [disabled]="waitAfterSave">
                    Enviar Pedido
                </button>
                <button 
                    mat-stroked-button 
                    class="boton-style"
                    [ngClass]="{ 'seleccionado': alarma.seleccionado }"
                    (click)="toggleSeleccion(alarma)"
                    [disabled]="waitAfterSave">
                    {{ alarma.seleccionado ? 'Deseleccionar' : 'Añadir a Pedido' }}
                </button>
            </div>
        </div>
        <mat-divider class="mat-divider-style"></mat-divider>
    </div>
    <p *ngIf="tanquesConAlarmasNivel.length === 0" class="negro">Ningún tanque presenta alarmas de tener un nivel bajo en los establecimientos actuales</p>
</div>
<div mat-dialog-actions class="mat-dialog-actions align-end dialog-end">
    <button 
        *ngIf="tanquesSeleccionados().length > 0" 
        mat-fab extended
        class="recargar"
        (click)="recargarSeleccionados()">
        <mat-icon>autorenew</mat-icon>
        Enviar Pedidos {{tanquesSeleccionados().length}}
    </button>
    <button mat-button mat-dialog-close cdkFocusInitial class="margin-left-auto">Cerrar</button>
</div>